const config = {
  appName: 'KMS Kontrol',
  slogan: 'Admin Panel for Kreatize Manufacturing Services and Kaktus'
};

export default config